import { SEO, breadcrumbJsonLd } from "@/components/SEO";
import React from "react";
import { articulos } from "@/data/articulos";
import { ArticuloCard } from "@/components/ArticuloCard";
import { ArticuloDestacado } from "@/components/ArticuloDestacado";
import { ClownNose, CometaBanner, CometaSwoosh, LiveBackground } from "@/components/ClownNose";

const categorias = [
  { nombre: "Utopías", desc: "Reflexiones Dra. Cometa.", color: "bg-cometa-marino text-white" },
  { nombre: "Para Vivir Mejor", desc: "Invitados expertos.", color: "bg-cometa-dorado text-cometa-tinta" },
  { nombre: "Cultura", desc: "Reflexiones y recomendaciones.", color: "bg-cometa-celeste text-cometa-tinta" },
  { nombre: "Voces de Utopistas", desc: "Artículos escritos por los adultos mayores.", color: "bg-cometa-carmesi text-white" },
  { nombre: "Tu Herencia, Mi Receta", desc: "Recetas con historia familiar.", color: "bg-cometa-tinta text-cometa-crema" },
];

export default function Blog() {
  return (
    <div>
      <SEO title="Revista Cometa · Blog de bienestar, cultura y comunidad" jsonLd={breadcrumbJsonLd([{ name: "Revista Cometa", path: "/blog" }])} description="Utopías, Para Vivir Mejor, Cultura, Voces de Utopistas y Tu Herencia, Mi Receta. Artículos y reflexiones de Dra. Cometa e invitados expertos." />
      <section className="bg-cometa-dorado relative overflow-hidden">
        <LiveBackground />
        <CometaSwoosh className="absolute inset-0 w-full h-full" color="#FFFFFF" opacity={0.3} />
        <div className="relative max-w-6xl mx-auto px-6 py-16 lg:py-28 grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3 mb-4 text-cometa-tinta/80" data-testid="blog-masthead">
              <ClownNose size={16} /><span className="eyebrow">Revista Cometa</span><span className="h-px w-16 bg-cometa-tinta/25" /><span className="font-script text-2xl text-cometa-carmesi">Edición {new Date().getFullYear()}</span>
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-8xl leading-[0.92] mb-6 text-cometa-tinta">Conocimiento, voces <em className="text-cometa-carmesi">y nuevas miradas.</em></h1>
            <p className="max-w-2xl text-lg text-cometa-tinta/80 leading-relaxed">
              Un espacio donde especialistas, distintas generaciones y experiencias se encuentran para compartir conocimiento, ideas e historias sobre los temas que nos atraviesan como personas y como sociedad.
            </p>
          </div>
          <CometaBanner variant="portrait" className="lg:col-span-2 aspect-[4/5] max-w-sm mx-auto w-full" />
        </div>
      </section>

      <div className="bg-cometa-tinta text-cometa-crema overflow-hidden py-3 border-y border-cometa-dorado/30" data-testid="blog-ticker" aria-hidden="true">
        <div className="flex whitespace-nowrap animate-marquee gap-10 font-display text-lg w-max">
          {[...categorias, ...categorias].map((c, i) => <span key={i} className="inline-flex items-center gap-4"><span className="h-2 w-2 rounded-full bg-cometa-dorado" />{c.nombre}</span>)}
        </div>
      </div>

      <section className="relative overflow-hidden blog-aurora"><LiveBackground /><div className="relative max-w-6xl mx-auto px-6 py-16 md:py-24">
        <div className="flex items-end justify-between mb-8"><h2 className="eyebrow text-cometa-marino/70">Artículos</h2><span className="font-script text-2xl text-cometa-marino/60">{articulos.length === 1 ? "Nuestra primera nota · más muy pronto" : `${articulos.length} notas para leer con calma`}</span></div>
        <div data-testid="blog-articulos">
          <div className="mb-6"><ArticuloDestacado a={articulos[0]} /></div>
          {articulos.length > 1 && <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articulos.slice(1).map((a, i) => <ArticuloCard key={a.slug} a={a} index={i + 1} />)}
          </div>}
        </div>
      </div></section>

      <section className="max-w-6xl mx-auto px-6 pb-24">
        <h3 className="text-sm tracking-[0.3em] text-cometa-marino/60 mb-6">CATEGORÍAS</h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {categorias.map((c) => (
            <div key={c.nombre} className={`${c.color} rounded-2xl p-6 hover:-translate-y-1 transition`}>
              <h4 className="text-xl mb-2 font-display">{c.nombre}</h4>
              <p className="text-sm opacity-80">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
